import React from 'react'
import { Header, PageHeaderBackIcon } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { STATES } from '../../../../../lib/routes'
import { $state } from '../../../ng-compat/imports'
import { peekPostPaymentRedirectUrl } from '../../../util/post-payment-redirect'
import { useAppSelector } from '../../../state/hooks'
import { selectPayAccountBalance } from '../../../state/slices/currentSale/currentSaleSlice'

interface Props {
  isQuote?: boolean
  isReturn?: boolean
  isExchange?: boolean
}

export const BackToSaleHeader: React.FC<Props> = ({
  isQuote = false,
  isReturn = false,
  isExchange = false,
}) => {
  const t = useT()
  const postPaymentRedirectUrl = peekPostPaymentRedirectUrl()
  const hasRedirect = postPaymentRedirectUrl !== null
  const payAccountBalance = useAppSelector(selectPayAccountBalance)
  const isAbpFlow = hasRedirect || Boolean(payAccountBalance?.abpTransactionId)

  const getAbpLabel = () => {
    return t('Account balance payment', {
      _context: 'Payment screen header for account balance payment',
    })
  }

  const getLabel = () => {
    if (isAbpFlow) {
      return getAbpLabel()
    }
    if (isQuote) {
      return t('Quote', {
        _context: 'Payment screen header for quote created sale',
      })
    }
    if (isExchange) {
      return t('Exchange', {
        _context: 'Payment screen header for exchange sale',
      })
    }
    if (isReturn) {
      return t('Return', {
        _context: 'Payment screen header for return sale',
      })
    }
    return t('Sale', {
      _context: 'Payment screen header for regular sale',
    })
  }

  const handleBackClick = (e: React.MouseEvent) => {
    e.preventDefault()
    if (postPaymentRedirectUrl) {
      window.location.assign(postPaymentRedirectUrl)
    } else if (payAccountBalance?.abpTransactionId) {
      // No redirect URL (common in local dev) — force a full reload to clear
      // the stale ABP Redux state and return to a clean sell screen.
      window.location.assign('/webregister/')
    } else {
      $state.go(STATES.SALE)
    }
  }

  return (
    <Header type="hero" level="1" className="vs-page-header">
      {$state.current.name !== STATES.SALE_CONFIRMATION && (
        <PageHeaderBackIcon href="/webregister/" onClick={handleBackClick} />
      )}
      {getLabel()}
    </Header>
  )
}
